import React from 'react'
import { connect } from 'react-redux'
import { Modal, FormGroup, FormControl } from 'react-bootstrap'
import { dropAssignment } from '../../actions/coursesActionCreators';
import { getStudent } from '../../actions/studentsActionCreators';

class ModalLeaveWaitlist extends React.Component {
  state = {
    value: '',
    disabled: true
  }

  handleChange = ({target: { value }}) => {
    this.setState({
      value,
      disabled: value !== 'DROP'
    })
  }

  handleSubmit = event => {
    event.preventDefault()

    this.props
      .dropAssignment(this.props.assignment.id)
      .then(() => {
        this.props.getStudent()
        this.handleClose()
      });
  }

  handleClose = () => {
    this.setState({
      value: '',
      disabled: true
    })
    this.props.onClose()
  }

  render() {
    const {
      disabled,
      value
    } = this.state
    const { assignment } = this.props

    return (
      <Modal show={!!assignment.id} onHide={this.handleClose}>
        <Modal.Header closeButton>
          <h3 className="modal-title">
            Drop Class
          </h3>
          {/* <Modal.Title>
            Drop {assignment.slug}{assignment.longname ? `: ${assignment.longname}` : ''} ?
          </Modal.Title> */}
        </Modal.Header>
        <form onSubmit={this.handleSubmit}>
          <Modal.Body>
            <p className="mt-1">Are you sure you want to drop <b>{assignment.longname ? assignment.longname : ''} ({assignment.slug})</b></p>
            <p className="mt-2">
              Type <span className="textColorPurple">DROP</span> to confirm
            </p>
            <FormGroup controlId="formControlsSelect">
              <FormControl componentClass="input" value={value} onChange={this.handleChange} />
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <div className="buttonsSpaceBetween">
              <button className="btn btn-ter" type="button" onClick={this.handleClose}>
                Cancel
              </button>
              <button className="btn btn-primary" type="submit" disabled={disabled}>
                Drop
              </button>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

function mapDispatchToProps () {
  return {
    dropAssignment,
    getStudent
  }
}

export default connect(null, mapDispatchToProps())(ModalLeaveWaitlist)


// WEBPACK FOOTER //
// ./src/components/common/ModalDropAssignment.js